<template>
  <TwoColumnPageTemplate>
    <template v-slot:header>
      <Header :breadcrumb-items="breadcrumbItems" />
    </template>
    
    <template v-slot:footer>
      <Footer />
    </template>

    <template v-slot:aside>
      <SearchItemWidget
        v-model:keyword="keywordValue"
      />
      <LargeCategoryWidget />

      <div class="mt-5">
        <AnnounceWidget />
      </div>
    </template>

    <div>
      <h1>商品一覧</h1>
      <ItemSearchPageSection
        :keyword="keywordValue"
      />
    </div>
  </TwoColumnPageTemplate>
  <GuideTour
    name="STEPS_01001_ItemSearchPage"
    :steps="STEPS_01001_ItemSearchPage"
  ></GuideTour>
</template>

<script setup lang="ts">
import TwoColumnPageTemplate from '@/components/templates/TwoColumnPageTemplate.vue'
import Header from '@/components/organisms/Header.vue'
import Footer from '@/components/organisms/Footer.vue'
import AnnounceWidget from '@/components/organisms/widgets/AnnounceWidget.vue'
import LargeCategoryWidget from '@/components/organisms/widgets/LargeCategoryWidget.vue'
import ItemSearchPageSection from '@/components/organisms/sections/01001_ItemSearchPageSection.vue'
import { useBreadcrumbsFunc } from '@/utils/breadcrumbs'
import SearchItemWidget from '../organisms/widgets/SearchItemWidget.vue'
import {
  computed,
  ref,
} from 'vue'
import GuideTour from '@/components/atoms/GuideTour.vue'
import STEPS_01001_ItemSearchPage from '@/utils/tourguide/STEPS_01001_ItemSearchPage'

/**
 * パンくずリスト
 */
const breadcrumbItems = computed(() => {
  return [useBreadcrumbsFunc().getTopItem(false)]
})

// キーワード
const keywordValue = ref<string | undefined>(undefined)
</script>

<style scoped>
</style>
